export default __webpack_public_path__ + "static/media/tileovercutafter.221f5748.jpg";